import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { MainTitle, Spinner } from '../../../../common/index.jsx';
import DatesDetail from '../../../../common/FriOpen/Dates/DatesDetails.jsx';
import { useGetDateQuery } from '../../../../../redux/services/fo_dates.jsx';

const DatesDetailPublicPage = () => {
  const { t } = useTranslation();
  const { dateId } = useParams();

  const { data: date, isLoading: isLoadingDate } = useGetDateQuery(dateId);

  return (
    <>
      <MainTitle title={t('FRI akcia - detail termínu')} backAction={true} />

      {isLoadingDate ? <Spinner /> : <DatesDetail date={date} />}
    </>
  );
};

export default DatesDetailPublicPage;
